import { Dispatch } from 'react';
import {
  AddressDetails,
  InsuranceJourneyAddressDetailsType
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const AddressDetailsPageEventHandlers = (
  addressDetails: InsuranceJourneyAddressDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeOvernightParkedAddress: (value: AddressDetails) => {
      dispatch({
        type: 'set-address-details',
        addressDetails: {
          ...addressDetails,
          overnightParkedAddress: { ...value }
        }
      });
    },
    onChangeIsThisCorrespondenceAddress: (value: boolean) => {
      dispatch({
        type: 'set-address-details',
        addressDetails: {
          ...addressDetails,
          isThisCorrespondenceAddress: value
        }
      });
    },
    onChangeCorrespondenceAddress: (value: AddressDetails) => {
      dispatch({
        type: 'set-address-details',
        addressDetails: {
          ...addressDetails,
          correspondenceAddress: { ...value }
        }
      });
    },
    onChangeLocationVehicleParkedOvernight: (value: string) => {
      dispatch({
        type: 'set-address-details',
        addressDetails: {
          ...addressDetails,
          locationVehicleParkedOvernight: value
        }
      });
    },
    onChangeNumberOfCarsAtHousehold: (value: string) => {
      dispatch({
        type: 'set-address-details',
        addressDetails: { ...addressDetails, numberOfCarsAtHousehold: value }
      });
    }
  };
};
